<script>
  import { link } from "svelte-spa-router";
  import { filtered, term } from "../../store/RecettesStore";
  import { fade } from "svelte/transition";

  //<button on:click={OneRecette(item.id)}>Click me {item.id}</button>
</script>

{#if $filtered}
  <div class="container-fluid">
    <h6>Liste des recettes</h6>

    <form class="d-flex" role="search">
      <input
        bind:value={$term.titre}
        class="form-control me-2"
        type="search"
        placeholder="type/recettes"
        aria-label="Search"
        size="25px"
      />
      <select bind:value={$term.type}>
        <option value="all" />
        <option value="salée">salée</option>
        <option value="dessert">dessert</option>
        <option value="pâte">pâte</option>
      </select>
    </form>
  </div>
   <div class="col-xl-12 col-lg-12">
    <table width="100%" class="table table-primary table-striped table-bordered">
      <thead>
        <tr>
          <td>ID</td>
          <td>Nom</td>
          <td>note</td>
        </tr>
      </thead>
      <tbody>
        {#each $filtered as item}
          <tr in:fade>
            <td
              ><span class="badge rounded-pill bg-primary"
                ><a href="/recette/{item.id}" use:link>{item.id}</a></span
              ></td
            >
            <td>{item.titre}</td>
            <td
              ><span
                class="fa fa-star {item.note >= 1 ? 'checked' : 'notchecked'}"
              />
              <span
                class="fa fa-star  {item.note >= 2 ? 'checked' : 'notchecked'}"
              />
              <span
                class="fa fa-star  {item.note >= 3 ? 'checked' : 'notchecked'}"
              />
              <span
                class="fa fa-star  {item.note >= 4 ? 'checked' : 'notchecked'}"
              />
              <span
                class="fa fa-star  {item.note >= 5 ? 'checked' : 'notchecked'}"
              /></td
            >
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
{/if}

<style>
  table {
    font-size: 0.85em;
  }
  .checked {
    color: orange;
  }
  .notchecked {
    color: lightslategrey;
  }
</style>
